// extracted by mini-css-extract-plugin
export var button = "_ms-0";